// src/Pages/PharmacistDashboard/InventoryRestocking.js

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  IconButton,
  Collapse,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore,
  ShoppingCart as ReorderIcon,
} from '@mui/icons-material';
import {
  inventoryMockData,
  supplierMockData,
  restockHistoryMockData,
} from '../../data/pharmacistInventoryRestockingMockData';

const InventoryRestocking = () => {
  const [lowStockMedications, setLowStockMedications] = useState(
    inventoryMockData.filter(
      (item) =>
        item.stockStatus === 'Low Stock' || item.stockStatus === 'Out of Stock'
    )
  );
  const [expandedItem, setExpandedItem] = useState(null);
  const [orderDetails, setOrderDetails] = useState({
    supplier: '',
    medicationId: '',
    quantity: '',
  });
  const [restockHistory] = useState(restockHistoryMockData);

  const handleExpandItem = (id) => {
    setExpandedItem((prev) => (prev === id ? null : id));
  };

  const handleOrderChange = (event) => {
    const { name, value } = event.target;
    setOrderDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePlaceOrder = () => {
    // Logic for placing a new restock order
    alert(
      `Order placed for medication ID: ${orderDetails.medicationId}, quantity: ${orderDetails.quantity}, supplier: ${orderDetails.supplier}`
    );
    setOrderDetails({ supplier: '', medicationId: '', quantity: '' });
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h4' gutterBottom>
        Inventory Restocking
      </Typography>

      {/* Low Stock List */}
      <Typography variant='h6'>Low Stock Medications</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{ padding: 2, maxHeight: 400, overflow: 'auto' }}
          >
            <List>
              {lowStockMedications.map((item) => (
                <div key={item.id}>
                  <ListItem
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <ListItemText
                      primary={`${item.name} (${item.category})`}
                      secondary={`Stock: ${item.stock} | Expiry: ${item.expiry}`}
                    />
                    <IconButton onClick={() => handleExpandItem(item.id)}>
                      {expandedItem === item.id ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )}
                    </IconButton>
                  </ListItem>
                  <Collapse
                    in={expandedItem === item.id}
                    timeout='auto'
                    unmountOnExit
                  >
                    <Box sx={{ padding: 2, backgroundColor: '#f5f5f5' }}>
                      <Typography variant='body2'>
                        Last Reorder:{' '}
                        {item.reorderHistory || 'No reorder history available'}
                      </Typography>
                      <Button
                        variant='contained'
                        color='primary'
                        startIcon={<ReorderIcon />}
                        sx={{ mt: 2 }}
                        onClick={() => handleExpandItem(item.id)}
                      >
                        Reorder
                      </Button>
                    </Box>
                  </Collapse>
                </div>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>

      {/* Restock Order Form */}
      <Typography variant='h6' sx={{ mt: 4 }}>
        Place Restock Order
      </Typography>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Select Medication</InputLabel>
              <Select
                name='medicationId'
                value={orderDetails.medicationId}
                onChange={handleOrderChange}
              >
                <MenuItem value=''>Select Medication</MenuItem>
                {lowStockMedications.map((medication) => (
                  <MenuItem key={medication.id} value={medication.id}>
                    {medication.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Select Supplier</InputLabel>
              <Select
                name='supplier'
                value={orderDetails.supplier}
                onChange={handleOrderChange}
              >
                <MenuItem value=''>Select Supplier</MenuItem>
                {supplierMockData.map((supplier) => (
                  <MenuItem key={supplier.id} value={supplier.name}>
                    {supplier.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label='Quantity'
              name='quantity'
              variant='outlined'
              value={orderDetails.quantity}
              onChange={handleOrderChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant='contained'
              color='primary'
              fullWidth
              onClick={handlePlaceOrder}
            >
              Place Order
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Restock History */}
      <Typography variant='h6' sx={{ mt: 4 }}>
        Restock History
      </Typography>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <List>
          {restockHistory.map((order) => (
            <ListItem key={order.id}>
              <ListItemText
                primary={`Medication: ${order.medication}`}
                secondary={`Quantity: ${order.quantity} | Supplier: ${order.supplier} | Expected Delivery: ${order.expectedDelivery}`}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default InventoryRestocking;
